import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ImageUpload from './ImageUpload';
import CanvasEditor from './CanvasEditor';
import { UploadedImage } from '../types';

const ProfilePictureGenerator: React.FC = () => {
    const navigate = useNavigate();
    const [uploadedImage, setUploadedImage] = useState<UploadedImage | null>(null);

    const handleImageUpload = useCallback((image: UploadedImage) => {
        setUploadedImage(image);
    }, []);

    const handleBackToHome = () => {
        navigate('/');
    };

    return (
        <div className="generator-page">
            <div className="generator-header">
                <h1 className="generator-title">Profile Picture Generator</h1>
                <p className="generator-subtitle">
                    Upload, adjust, and download your framed photo
                </p>
                <button 
                    onClick={handleBackToHome}
                    style={{
                        background: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        marginTop: '10px'
                    }}
                >
                    ← Back to Event
                </button>
            </div>
            
            <div className="generator-content">
                <div className="left-panel">
                    <ImageUpload onImageUpload={handleImageUpload} />
                    <p style={{fontSize:'0.9rem', color:'#6b7280', marginTop: 8}}>
                        Tip: Use a clear portrait photo for best results.
                    </p>
                </div>
                
                <div className="right-panel">
                    <CanvasEditor uploadedImage={uploadedImage} />
                </div>
            </div>
        </div>
    );
};

export default ProfilePictureGenerator;